import { forEachParam } from './forEachParam.js';
import { store } from '@/store/index.js';

/**
 * @name getClubForParam
 * @description Gets the club if it's missing from the state
 * @param {Object} params - Keys are the param and the value is the store getter to be called
 * @returns undefined
 *
 * @example
 * // triggers the "club/getById" store action if the "competitionId" param is found on the route
 * router.beforeEach(getClubForParam({
 *     competitionId: `competition/getById`
 * }));
 */

function getClubForParam (params) {
	return async to => {
		// an array of params that are present on the route and the "params" variable
		const foundParams = Object.entries(
			to.params
		).filter(param => Object.keys(params).includes(param[0]));

		if (!foundParams.length) return;

		await forEachParam(
			foundParams,
			async (key, value) => {
				/*
					const retrievedObject = store.getters[`competition/getById`](`fake-competition-id`);
					console.log(`the competition retrieved from the state is:`, retrievedObject);
				*/
				const retrievedObject = store.getters[params[key]](value);

				// the object retrieved has the club ID param
				if (retrievedObject?.clubId) {
					// retrieve the club from the state with the club ID from the retrieved object
					const club = store.getters[`club/getById`](retrievedObject.clubId);

					// get the club using the store if the club is not found on the state
					if (!club) await store.dispatch(`club/getById`, retrievedObject.clubId);
				}
			}
		);
	};
}

export { getClubForParam };
